/* eslint-disable react/destructuring-assignment */

import React from 'react';
import isArray from 'lodash/isArray';
import moment from 'moment';
import Admin from 'hive-admin/src/components/Admin';

import Tag from 'antd/lib/tag';
import Icon from 'antd/lib/icon';
import Table from 'antd/lib/table';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { List } from 'immutable';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Modifier,
  EditorState,
} from 'draft-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import htmlToDraft from 'html-to-draftjs';
import ActionWithFormModal from 'hive-admin/src/components/ActionWithFormModal';

import Query from 'hive-admin/src/components/Query';
import Type from '../modules/types';

// import './posts.styl';

const getValueForFieldDefault = value => (
  value && value.length
    ? value
    : undefined
);

class ActionWithFormModalAndChangableTitle extends ActionWithFormModal {
  renderAction(props) {
    return super.renderAction({
      ...props,
      title: this.props.getTitle ? this.props.getTitle(props) : props.title,
    });
  }
}

const ActionNewsletter = [
  config => ActionWithFormModalAndChangableTitle.create(config),
  {
    label: null,
    section: 'top',
    title: 'Send Newsletter',
    // width: '100%',
    col: 24,
    style: { width: '100%' },
    getModalTitle: () => 'Send Newsletter',
    getTitle: () => `Send Newsletter${
      window.SELECTED_ROW_KEYS && window.SELECTED_ROW_KEYS.length
        ? ` (${window.SELECTED_ROW_KEYS.length})`
        : ''
      }`,
    shouldOpenModal: () => {
      if (!window.SELECTED_ROW_KEYS.length) {
        Admin.showMessage(
          'Please select some content first',
          'error',
        );
        return false;
      }
      return true;
    },
    renderAfterForm: props => (
      <Query
        client={props.client}
        url={`/posts?query=${window.btoa(JSON.stringify({
          where: { _id: { IN: window.SELECTED_ROW_KEYS } },
          populate: { topics: true },
        }))}`}
      >
        {({ data, loading }) => {
          let dataSource = [];
          if (data && data.data && data.data.data) {
            const items = data.data.data;
            const topics = {};
            items.forEach((item) => {
              const topic = item.topics[0] ? item.topics[0].name : null;
              if (topic) {
                topics[topic] = topics[topic] || {
                  count: 0,
                  name: topic,
                };
                topics[topic].count++;
              }
            });
            dataSource = Object.values(topics).sort((a, b) => (
              a.count > b.count ? -1
                : a.count < b.count ? 1
                  : 0
            ));
          }
          return (
            <Table
              // bordered
              className="newsletter-table"
              loading={loading}
              pagination={false}
              scroll={{ y: 200 }}
              style={{ marginTop: '40px' }}
              rowKey="name"
              columns={[{
                title: 'Topic',
                dataIndex: 'name',
                key: 'name',
                width: '80%',
              }, {
                title: 'Count',
                dataIndex: 'count',
                key: 'count',
                align: 'right',
                width: '20%',
              }]}
              dataSource={dataSource}
            />
          );
        }}
      </Query>
    ),
    fields: [
      ['FieldText', {
        name: 'title',
        label: 'Title',
        placeholder: 'Title of the email',
        rules: [['validation.isRequired']],
      }],
      ['FieldSelect', {
        name: 'recipients',
        label: 'Send to',
        initialValue: 'me',
        hidden: [() => true],
        choices: [
          { label: 'Only me', value: 'me' },
          // { label: 'Clients', value: 'clients' },
          // { label: 'Employees', value: 'employees' },
          // { label: 'Everyone', value: 'everyone' },
        ],
      }],
      ['FieldConnectionSelect', {
        name: 'groups',
        label: 'Select Groups',
        placeholder: 'Narrow down to one or multiple groups',
        url: '/groups',
        mode: 'multiple',
        skip: [
          props => (
            !props.form || props.form.getFieldValue('recipients') === 'me'
          ),
        ],
      }],
    ],
    actions: [
      // ['Action', {
      //   name: 'clear',
      //   title: 'Clear',
      //   type: 'danger',
      //   style: { width: '30%' },
      //   onClick: (props) => {
      //     props.modalAction.setState({ visible: false });
      //     window.SET_SELECTER_ROW_KEYS([]);
      //   },
      // }],
      ['ActionWithFormBasedRequest', {
        name: 'send',
        title: 'Send to Me',
        // style: { width: '30%' },
        getRequestConfig: (props, data) => ({
          url: 'posts/newsletter',
          method: 'post',
          data: {
            ...data,
            posts: window.SELECTED_ROW_KEYS,
          },
        }),
      }],
    ],
  },
];

const FILTERS = [
  ['FilterRegexSearch', {
    id: 'search',
    paths: [
      'title',
    ],
    col: 12,
    caseInsensitive: true,
    section: 'top',
  }],
  ['FilterField', {
    id: 'sort',
    label: null,
    section: 'top',
    col: 12,
    VALUES_MAP: {
      publishedDesc: { publishedAt: -1 },
      publishedAsc: { publishedAt: 1 },
      titleDesc: { title: 1 },
      titleAsc: { title: -1 },
    },
    buildQuery: (value, builder, filter) => (
      filter.VALUES_MAP[value]
        ? builder.add('sort', { ...filter.VALUES_MAP[value] })
        : builder.add('sort', { ...filter.VALUES_MAP.publishedDesc })
    ),
    getValueForField: value => (value && value.length ? value : undefined),
    field: ['FieldSelect', {
      name: 'sort',
      placeholder: 'Sort',
      defaultValue: 'publishedDesc',
      initialValue: 'publishedDesc',
      prepareValueForInput: value => (value ? value : 'publishedDesc'),
      choices: [{
        label: '↓ Published',
        value: 'publishedDesc',
      }, {
        label: '↑ Published',
        value: 'publishedAsc',
      }, {
        label: '↓ Title',
        value: 'titleDesc',
      }, {
        label: '↑ Title',
        value: 'titleAsc',
      }],
    }],
  }],
  ['FilterField', {
    id: 'category',
    label: null,
    section: 'top',
    col: { md: 8, xs: 24 },
    propsFromPage: props => ({ client: props.client }),
    buildQuery: (value, builder) => value && value.length && builder.add(
      'where',
      { categories: { IN: isArray(value) ? value : [value] } },
    ),
    getValueForField: getValueForFieldDefault,
    field: ['FieldConnectionSelect', {
      name: 'cateogry',
      url: '/categories',
      placeholder: 'Categories',
      mode: 'multiple',
      allowClear: true,
      extraQuerySortProps: { name: 1 },
      searchPaths: ['name'],
    }],
  }],
  ['FilterField', {
    id: 'topics',
    label: null,
    section: 'top',
    col: { md: 8, xs: 24 },
    propsFromPage: props => ({ client: props.client }),
    buildQuery: (value, builder) => value && value.length && builder.add(
      'where',
      { topics: { IN: isArray(value) ? value : [value] } },
    ),
    getValueForField: getValueForFieldDefault,
    field: ['FieldConnectionSelect', {
      name: 'topics',
      url: '/tags',
      placeholder: 'Topics',
      mode: 'multiple',
      allowClear: true,
      extraQuerySortProps: { name: 1 },
      getExtraQueryConditions: (/* props */) => [{ type: 'TOPIC' }],
      searchPaths: ['name'],
    }],
  }],
  ['FilterField', {
    id: 'regions',
    label: null,
    section: 'top',
    col: { md: 8, xs: 24 },
    propsFromPage: props => ({ client: props.client }),
    buildQuery: (value, builder) => value && value.length && builder.add(
      'where',
      { regions: { IN: isArray(value) ? value : [value] } },
    ),
    getValueForField: getValueForFieldDefault,
    field: ['FieldConnectionSelect', {
      name: 'regions',
      url: '/tags',
      placeholder: 'Regions',
      getExtraQueryConditions: (/* props */) => [{ type: 'REGION' }],
      mode: 'multiple',
      allowClear: true,
      extraQuerySortProps: { name: 1 },
      searchPaths: ['name'],
    }],
  }],
  ActionNewsletter,
  ['FilterHidden', {
    id: 'extras',
    section: 'top',
    build: (builder) => {
      builder.add('populate', { topics: true });
      builder.add('populate', { regions: true });
      builder.add('populate', { categories: true });
    },
  }],
  ['FilterPagination', {
    id: 'pagination',
    section: 'bottom',
  }],
];

const COLUMNS = [
  {
    path: 'title',
    sort: 'title',
    render: record => (
      <Link
        to={`/${record.type.toLowerCase().replace(/s?$/, 's')
          }/${record._id
          }`}
      >
        {record.title}
      </Link>
    ),
  },
  {
    title: 'Categories',
    // eslint-disable-next-line max-len
    render: record => record.categories.map(({ _id, name }) => <Tag key={_id}>{name}</Tag>),
  },
  {
    title: 'Topics',
    path: 'topics',
    // eslint-disable-next-line max-len
    render: record => record.topics.map(({ _id, name }) => <Tag key={_id}>{name}</Tag>),
  },
  {
    title: 'Regions',
    // eslint-disable-next-line max-len
    render: record => record.regions.map(({ _id, name }) => <Tag key={_id}>{name}</Tag>),
  },
  // {
  //   title: 'Priority',
  //   path: 'priority',
  //   render: record => (
  //     <div style={{ width: '100%', textAlign: 'center' }}>
  //       <Icon
  //         type="star"
  //         theme={record.priority === 'MAJOR' ? 'filled' : 'outlined'}
  //         title={`${record.priority[0]
  //           }${record.priority.slice(1).toLowerCase()
  //           }`}
  //       />
  //     </div>
  //   ),
  // },
  {
    title: 'Published',
    path: 'publishedAt',
    sort: 'published',
    render: (record) => {
      const now = Date.now();
      const then = new Date(record.publishedAt).getTime();
      const diff = now - then;
      if (diff < 0) {
        // future
        return moment(record.publishedAt).fromNow();
      }
      if ((diff / 60 / 60 / 1000) < 1) {
        // less then an hour ago
        return moment(record.publishedAt).fromNow();
      }
      // more then a week ago
      return moment(record.publishedAt).format('LLL');
    },
  },
  // {
  //   path: 'access',
  //   render: ({ access = [] }) => {
  //     access = isArray(access)
  //       ? access.sort().join(',')
  //       : 'CLIENT,EMPLOYEE';
  //     switch (access) {
  //       case 'CLIENT': return 'Clients';
  //       case 'EMPLOYEE': return 'Employees';
  //       case 'CLIENT,EMPLOYEE': return 'Everyone';
  //       case '': default: return 'Private';
  //     }
  //   },
  // },
  {
    path: 'actions',
    title: '',
    width: '1%',
    render: (() => {
      const action = Admin.compileFromLibrary(
        ['ActionWithRequest', {
          name: 'delete',
          type: 'ghost',
          icon: 'delete',
          size: 'small',
          shape: 'circle',
          title: null,
          method: 'delete',
          messageWorking: 'Deleting...',
          messageSuccess: 'Deleted!',
          handleSuccess: (data, props) => props.reload(),
        }],
      );
      return (record, column, props) => action.render({
        ...props,
        url: `posts/${record._id}`,
      });
    })(),
  },
];

export default [
  ['PageArchiveTableSelectable', {
    path: '/all',
    icon: 'unordered-list',
    title: 'All Posts',
    label: 'All Posts',
    loadUrl: '/posts',
    createButtonSupported: false,
    columns: [
      COLUMNS[0],
      { path: 'type', title: 'Type' },
      ...COLUMNS.slice(1),
    ],
    filters: FILTERS,
    activity: 'archive',
    loadExtractData: response => (
      response
        ? { count: response.data.count, data: response.data.data }
        : { count: 0, data: [] }
    ),
    redirect: [['redirect.unauthorized']],
  }],
  ...Type.POST_TYPE.map((type) => {
    const lower = type.toLowerCase();
    const plural = lower.replace(/s?$/, 's');
    const path = `/${plural}`;
    return [
      'GroupResource',
      {
        path,
        icon: (
          type === 'News'
          ? 'file-text'
          : type === 'Insight'
          ? 'info-circle'
          : type === 'Video'
          ? 'video-camera'
          : type === 'Perspective'
          ? 'audit'
          : type === 'POV'
          ? 'bar-chart'
          : undefined
        ),
        title: (
          type === 'POV'
          ? 'POVs'
          : `${plural[0].toUpperCase()}${plural.slice(1)}`
        ),
        archiveComponent: 'PageArchiveTableSelectable',
        archiveLoadUrl: '/posts',
        archiveConfig: {
          icon: (
            type === 'News'
              ? 'file-text'
              : type === 'Insight'
              ? 'info-circle'
              : type === 'Video'
              ? 'video-camera'
              : type === 'Perspective'
              ? 'audit'
              : type === 'POV'
              ? 'bar-chart'
              : undefined
          ),
          label: (
            type === 'POV'
            ? 'POVs'
            : `${plural[0].toUpperCase()}${plural.slice(1)}`
          ),
          title: (
            type === 'POV'
            ? 'POVs'
            : `${plural[0].toUpperCase()}${plural.slice(1)}`
          ),
        },
        topTitleKey: 'title',
        singleCreateConfig: {
          hidden: true,
          alias: `/${plural}`,
          title: `Create ${type}`,
        },
        singleCreateUrl: `/posts?type=${type}`,
        redirect: [['redirect.unauthorized']],
        filters: [
          ...FILTERS,
          ['FilterHidden', {
            id: 'type',
            section: 'top',
            build: (builder) => {
              builder.add('where', { type });
            },
          }],
        ],
        columns: COLUMNS,
        singleEditConfig: {
          actions: [
            ['ActionSave'],
            ['ActionDelete'],
            // ['ActionWithFormModal', {
            //   label: 'Send Notifications',
            //   title: 'Send Notifications',
            //   fields: [
            //     ['FieldConnectionSelect', {
            //       name: 'recipients',
            //       label: 'Recipients',
            //       placeholder: 'Type to select users',
            //       url: '/users',
            //       mode: 'multiple',
            //       rules: [['validation.isRequired']],
            //     }],
            //     ['FieldRadio', {
            //       name: 'multicategory',
            //       label: 'Send as',
            //       block: true,
            //       initialValue: false,
            //       choices: [{
            //         label: `${type} notification`,
            //         value: false,
            //       }, {
            //         label: 'Multy category notification',
            //         value: true,
            //       }],
            //     }],
            //   ],
            //   actions: [
            //     ['ActionWithFormBasedRequest', {
            //       title: 'Send',
            //       skip: [
            //         ['condition.checkViewer', 'role', '!==', 'ADMIN'],
            //       ],
            //       getRequestConfig: (props, data) => ({
            //         url: `posts/${props.data._id}/notify`,
            //         method: 'post',
            //         data,
            //       }),
            //     }],
            //   ],
            // }],
          ],
        },
        fields: [
          ['FieldText', {
            name: 'title',
            rules: [['validation.isRequired']],
            placeholder: 'Write something eye-catching',
          }],
          // ['FieldTextArea', {
          //   name: 'excerpt',
          //   sendEmpty: true,
          //   autoSize: { minRows: 2 },
          //   placeholder: 'Article excerpt used in the newsletter',
          //   // rules: [['validation.isString', {
          //   //   min: 0,
          //   //   max: 100,
          //   //   message: 'Excerpt must stay within 100 characters',
          //   // }]],
          // }],
          // ['FieldRadio', {
          //   name: 'unlisted',
          //   label: 'Listed In App',
          //   initialValue: false,
          //   choices: [
          //     { value: false, label: 'Listed' },
          //     { value: true, label: 'Unlisted' },
          //   ],
          //   block: true,
          // }],
          // ['FieldDatePicker', {
          //   name: 'publishedAt',
          //   label: 'Publish Date',
          //   showTime: { format: 'HH:mm' },
          //   format: 'DD.MM.YYYY. [at] HH:mm',
          //   style: { minWidth: '300px' },
          //   placeholder: 'Leave empty to publish immediately',
          // }],
          ['FieldConnectionSelect', {
            name: 'categories',
            placeholder: 'Select relevant categories',
            url: '/categories',
            mode: 'multiple',
            // col: { xl: 12, md: 24 },
            rules: [['validation.isRequired']],
          }],
          ['FieldConnectionSelect', {
            name: 'topics',
            placeholder: 'Select relevant topics',
            url: '/tags',
            mode: 'multiple',
            getExtraQueryConditions: (/* props */) => [{ type: 'TOPIC' }],
            col: { xl: 12, md: 24 },
            rules: [['validation.isRequired']],
          }],
          ['FieldConnectionSelect', {
            name: 'regions',
            placeholder: 'Select relevant regions',
            url: '/tags',
            mode: 'multiple',
            col: { xl: 12, md: 24 },
            getExtraQueryConditions: (/* props */) => [{ type: 'REGION' }],
          }],
          // ['FieldRadio', {
          //   name: 'priority',
          //   block: true,
          //   initialValue: type === 'News' ? 'MINOR' : 'MAJOR',
          //   choices: Type.POST_PRIORITY.map(value => ({
          //     label: `${value[0]}${value.slice(1).toLowerCase()}`,
          //     value,
          //   })),
          // }],
          // ['Divider', {
          //   name: 'notifyDivider',
          // }],
          // ['FieldSwitch', {
          //   name: 'notify',
          //   label: 'Notify Users',
          //   initialValue: false,
          //
          ['FieldRadio', {
            name: 'coverImageStyle',
            label: 'Image Style',
            block: true,
            initialValue: 'NONE',
            choices: [{
              label: 'None',
              value: 'NONE',
            }, {
              label: 'Wide',
              value: 'WIDE',
            }, {
              label: 'Full',
              value: 'FULL',
            }],
          }],
          ['FieldUploadRefsHorizontal', {
            name: 'cover',
            class: 'NIKOLA',
            label: 'Image',
            libraryLabel: 'Select',
            listType: 'picture',
            // rules: [['validation.isRequired']],
            accept: 'image/jpg,image/jpeg,image/png',
            skip: [[
              'condition.testFieldValue',
              'coverImageStyle',
              '===',
              'NONE',
            ]],
            getTransformations: (props) => {
              console.log('props getTransformations:', props);
              const transformations = [
                ['GM', { command: 'compress', maxWidth: 700 }],
              ];
              const style = props.form.getFieldValue('coverImageStyle');
              if (style === 'WIDE') {
                transformations.push(
                  ['GM', { command: '4x1' }],
                );
              }
              return transformations;
            },
            library: true,
            getLibraryItemDownloadSrc: item => item.file.src.replace(
              '.cdn',
              '',
            ),
          }],
          // ['FieldRadio', {
          //   name: 'coverResizeMode',
          //   label: 'Cover Image Mode',
          //   block: true,
          //   initialValue: 'COVER',
          //   choices: [{
          //     label: 'Normal',
          //     value: 'COVER',
          //   }, {
          //     label: 'Logo',
          //     value: 'CONTAIN',
          //   }],
          // }],
          ['Divider', {
            name: 'accessDivider',
          }],
          // ['FieldRadio', {
          //   name: 'access',
          //   block: true,
          //   prepareValueForInput: value => (
          //     isArray(value)
          //       ? value.sort().join(',')
          //       : ''
          //   ),
          //   prepareValueForForm: value => (
          //     value
          //       ? value.split(',').sort()
          //       : []
          //   ),
          //   choices: [{
          //     label: 'Private',
          //     value: '',
          //   }, {
          //     label: 'Clients',
          //     value: 'CLIENT',
          //   }, {
          //     label: 'Employees',
          //     value: 'EMPLOYEE',
          //   }, {
          //     label: 'Everyone',
          //     value: 'CLIENT,EMPLOYEE',
          //   }],
          //   initialValue: ['CLIENT', 'EMPLOYEE'],
          // }],
          ['Divider', {
            name: 'specificContentDivider',
          }],
          ...(
            type === 'Video'
              ? [
                ['FieldUploadRefs', {
                  name: 'video',
                  rules: [['validation.isRequired']],
                  accept: 'video/mp4',
                }],
              ]
              : [
                ['FieldRadio', {
                  name: 'attachmentType',
                  label: 'Attachment',
                  block: true,
                  initialValue: 'NONE',
                  choices: [{
                    label: 'None',
                    value: 'NONE',
                  }, {
                    label: 'Upload',
                    value: 'UPLOAD',
                  }, {
                    label: 'Link',
                    value: 'LINK',
                  }],
                }],
                ['FieldUploadRefs', {
                  name: 'attachment.file',
                  label: 'Attachment',
                  accept: 'application/pdf',
                  skip: [[
                    'condition.testFieldValue',
                    'attachmentType',
                    '!==',
                    'UPLOAD',
                  ]],
                }],
                ['FieldText', {
                  name: 'attachment.link',
                  label: 'Attachment Download Link',
                  // eslint-disable-next-line max-len
                  placeholder: 'Link to use for email downloads (leave empty to use attachment)',
                  skip: [[
                    'condition.testFieldValue',
                    'attachmentType',
                    '!==',
                    'LINK',
                  ]],
                }],
                // ['FieldRadio', {
                //   name: 'attachment.clientAccess',
                //   label: 'Attachment Access',
                //   block: true,
                //   initialValue: false,
                //   choices: [{
                //     label: 'Employees',
                //     value: false,
                //   }, {
                //     label: 'Everyone',
                //     value: true,
                //   }],
                // }],
                ['Divider', {
                  name: 'attachmentDivider',
                }],
                ['FieldWYSIWYG', {
                  name: 'body',
                  toolbarCustomButtons: [
                    ['FieldWYSIWYGPostLinkToolbarItem'],
                  ],
                  getToolbarConfig: props => ({
                    ...props.toolbarConfig,
                    inline: {
                      ...props.toolbarConfig.inline,
                      options: [
                        ...props.toolbarConfig.inline.options,
                        'superscript',
                        'subscript',
                      ],
                    },
                    image: {
                      ...props.toolbarConfig.image,
                      inputAccept: 'image/jpeg,image/jpg,image/png',
                    },
                  }),
                  rules: [['validation.isRequired']],
                  placeholder: 'Rich, in depth content',
                  editorConfig: {
                    handlePastedText: (text, html, editorState, onChange) => {
                      const contentBlock = htmlToDraft(
                        (text || '')
                          .trim()
                          .split(/\s*\n+\s*/g)
                          .map(blockText => `<p>${blockText}</p>`)
                          .join('')
                      );
                      let contentState = editorState.getCurrentContent();
                      contentBlock.entityMap.forEach((value, key) => {
                        contentState = contentState.mergeEntityData(key, value);
                      });
                      onChange(EditorState.push(
                        editorState,
                        Modifier.replaceWithFragment(
                          contentState,
                          editorState.getSelection(),
                          new List(contentBlock.contentBlocks)
                        ),
                        'insert-characters',
                      ));
                      return true;
                    },
                  },
                }],
              ]
          ),
        ],
      },
    ];
  }),
].reduce(
  (agr, page, i) => {
    if (i === 0) {
      agr.push(Admin.compileFromLibrary(page));
    } else {
      agr.push(...Admin.compileFromLibrary(page).pages);
    }
    return agr;
  },
  [],
);
